import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppContext } from "../contexts/AppContext";
import { utilReducerConstant } from "../store/reducerConstant";
import { updateProfile, getuserInfo } from "../store/actions/userActions";
import axiosHttp from "../config/axios.interceptor";
import Multiselect from "multiselect-react-dropdown";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "./const.prop";

const AddBasicInfo = () => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);
  // const [loading, setLoading] = useState(true);
  const { stateList, countryList, languageList, categoryList } = useSelector(
    (state) => state.utilData
  );
  const [basicInfo, setBasicInfo] = useState({
    fName: "",
    lName: "",
    // dob: "",
    gender: "",
    phoneNumber: "",
    whatsappNumber: "",
    address: {
      country: "101",
      countryName: "",
      state: "",
      stateName: "",
      city: "",
    },
    linkedinProfile: "",
    facebookProfile: "",
    instagramProfile: "",
    youtubeProfile: "",
    xProfile: "",
    language: [],
    skillsCategory: [],
    offerService: false,
  });
  const [error, setError] = useState({});

  useEffect(() => {
    if (userData) {
      const userCountryInfo = countryList.filter((item) => {
        return item.id === userData?.address?.countryId;
      });

      const userStateInfo = stateList.filter((item) => {
        return item.id === userData?.address?.stateId;
      });

      const filteredResults = languageList.filter((item1) =>
        userData?.userLanguages.some((item2) => item1.id === item2.language_id)
      );

      const filteredCategory = categoryList.filter((item1) =>
        userData?.userSkillsCategories.some(
          (item2) => item1._id === item2._id?.$oid
        )
      );

      setBasicInfo({
        fName: userData?.fName || "",
        lName: userData?.lName || "",
        // dob: userData?.dob || "",
        gender: userData?.gender || "",
        phoneNumber: userData?.phone || "",
        whatsappNumber: userData?.whatsapp || "",
        address: {
          country: userCountryInfo?.[0]?.id || "101",
          state: userStateInfo?.[0]?.id || "",
          city: userData?.address?.city || "",
        },
        linkedinProfile: userData?.linkedinProfile || "",
        facebookProfile: userData?.facebookProfile || "",
        instagramProfile: userData?.instagramProfile || "",
        youtubeProfile: userData?.youtubeProfile || "",
        xProfile: userData?.xProfile || "",
        language: filteredResults || [],
        skillsCategory: filteredCategory || [],
        offerService: userData?.offerService,
      });
    }
  }, [userData]);

  // useEffect(() => {
  //   fetchCategories();
  // }, []);

  // const fetchCategories = async () => {
  //   try {
  //     const getCategoriesList = await axiosHttp.get(`skills-category`);
  //     setCategories(getCategoriesList.data);
  //     setLoading(false);
  //   } catch (error) {
  //     if (error.response.status === 429) {
  //       appContext.updateNotificationState({
  //         show: true,
  //         message: errorResponseMessage(error),
  //         type: "error",
  //       });
  //       authContext.logout();
  //     }
  //     if (error.response.status === 400) {
  //       appContext.updateNotificationState({
  //         show: true,
  //         message: errorResponseMessage(error),
  //         type: "error",
  //       });
  //     }
  //     setCategories([]);
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  const handleBasicInfoChange = async (e) => {
    const addressFields = ["country", "state", "city"];
    const { name, value } = e.target;
    if (addressFields.indexOf(name) !== -1) {
      if (name === "country") {
        const newStateList = await axiosHttp.get(`states?country_id=${value}`);
        dispatch({
          type: utilReducerConstant.SET_STATE_LIST,
          payload: newStateList?.data?.data || [],
        });
        setBasicInfo({
          ...basicInfo,
          address: {
            ...basicInfo?.address,
            [name]: value,
            // state: newStateList?.data?.data?.[0]?.id || "",
          },
        });
      }
      if (name !== "country") {
        setBasicInfo({
          ...basicInfo,
          address: {
            ...basicInfo?.address,
            [name]: value,
          },
        });
      }
    }
    if (addressFields.indexOf(name) === -1) {
      setBasicInfo({
        ...basicInfo,
        [name]: value,
      });
    }
  };

  const successCallback = () => {
    dispatch(getuserInfo());
    // appContext.updateNotificationState({
    //   type: "success",
    //   message: "Contact info updated successfully",
    //   show: true,
    // });
    appContext.updateModalState();
  };

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    appContext.updateNotificationState({
      show: true,
      type: "error",
      message: e?.response?.data?.message,
    });
    appContext.updateModalState();
  };

  const formValidation = () => {
    let isValid = true;

    if (basicInfo.fName.trim().length < 3) {
      isValid = false;
      setError({ ...error, fName: "Enter minimum 3 characters" });
    }
    // if (!basicInfo.lName) {
    //   isValid = false;
    //   setError({ ...error, lName: "Last name is missing" });
    // }
    // if (!basicInfo.dob) {
    //   isValid = false;
    //   setError({ ...error, dob: "Date of Birth is missing" });
    // }
    // if (
    //   checkTimeGreaterThanCurrentDate({
    //     type: "dob",
    //     year: new Date(basicInfo.dob).getFullYear(),
    //   }) === false
    // ) {
    //   isValid = false;
    //   setError({ ...error, dob: "Age must be atleast 18" });
    // }
    // if (!basicInfo.gender) {
    //   isValid = false;
    //   setError({ ...error, gender: "Gender is missing" });
    // }
    if (basicInfo.skillsCategory.length === 0) {
      isValid = false;
      setError({
        ...error,
        skillsCategory: "Atleast one category is required",
      });
    }
    // if (!basicInfo.phoneNumber) {
    //   setError({ ...error, phoneNumber: "Phone number is missing" });
    //   isValid = false;
    // }
    // let testMobileRegex = new RegExp(/^[6-9]\d{9}$/);
    // if (!testMobileRegex.test(basicInfo.phoneNumber)) {
    //   isValid = false;
    //   setError({ ...error, phoneNumber: "Phone number is not matching" });
    // }
    // if (!basicInfo.whatsappNumber) {
    //   isValid = false;
    //   setError({ ...error, whatsappNumber: "Whatsapp number is missing" });
    // }
    // if (!testMobileRegex.test(basicInfo.whatsappNumber)) {
    //   isValid = false;
    //   setError({ ...error, whatsappNumber: "Whatsapp number is not matching" });
    // }
    // if (!basicInfo.address?.country) {
    //   isValid = false;
    //   setError({ ...error, country: "Country is missing" });
    // }
    // if (!basicInfo.address?.state) {
    //   isValid = false;
    //   setError({ ...error, state: "State is missing" });
    // }
    // if (!basicInfo.address?.city) {
    //   isValid = false;
    //   setError({ ...error, city: "City is missing" });
    // }
    // if (basicInfo.language.length === 0) {
    //   isValid = false;
    //   setError({ ...error, language: "Select atleast one language" });
    // }
    // if (!basicInfo.link) {
    //   isValid = false;
    //   setError({ ...error, link: "Link is missing" });
    // }
    // let testLinkRegex = new RegExp(
    //   /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi
    // );
    // if (!testLinkRegex.test(basicInfo.link)) {
    //   isValid = false;
    //   setError({ ...error, link: "Enter a valid link" });
    // }

    if (isValid) {
      handleSubmit();
    } else {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "Please fill the required fields",
      });
    }
  };

  const handleSubmit = () => {
    const userCountryInfo = countryList.filter((item) => {
      return item.id === basicInfo?.address?.country;
    });
    const userStateInfo = stateList.filter((item) => {
      return item.id === basicInfo?.address?.state;
    });
    const languageInfo = [];
    basicInfo.language.map((item) => {
      languageInfo.push(item.id);
    });
    const categoryInfo = [];
    basicInfo.skillsCategory.map((item) => categoryInfo.push(item._id));
    dispatch(
      updateProfile(
        {
          firstName: basicInfo?.fName || "",
          lastName: basicInfo?.lName || "",
          // dob: basicInfo?.dob || "",
          gender: basicInfo?.gender || "",
          phoneNumber: basicInfo?.phoneNumber || "",
          whatsappNumber: basicInfo?.whatsappNumber || "",
          address: {
            country: basicInfo?.address?.country || "",
            state: basicInfo?.address?.state || "",
            city: basicInfo?.address?.city || "",
          },
          languages: languageInfo || [],
          skillsCategory: categoryInfo || [],
          linkedinProfile: basicInfo?.linkedinProfile || "",
          facebookProfile: basicInfo?.facebookProfile || "",
          instagramProfile: basicInfo?.instagramProfile || "",
          youtubeProfile: basicInfo?.youtubeProfile || "",
          xProfile: basicInfo?.xProfile || "",
          offerService: basicInfo?.offerService || false,
        },
        successCallback,
        failureCallback
      )
    );
  };

  // return loading ? (
  //   <Loader />
  // ) : (

  return (
    <>
      <div
        className="modal-body"
        style={{ maxHeight: "26rem", overflow: "hidden auto" }}
      >
        <div className="row mt-3 basic-info-form">
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>First Name</span>

                <input
                  className="form-control py-4"
                  type="text"
                  name="fName"
                  value={basicInfo?.fName || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.fName && <p className="field-error">{error?.fName}</p>}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>Last Name</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="lName"
                  value={basicInfo?.lName || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.lName && <p className="field-error">{error?.lName}</p>}
          </div>
          {/* <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <input
                  className="form-control py-4"
                  type="date"
                  name="dob"
                  value={basicInfo?.dob || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
                <span>Date of Birth</span>
              </label>
            </div>
            {error?.dob && <p className="field-error">{error?.dob}</p>}
          </div> */}
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>Gender</span>
                <select
                  className="form-control gen-select select select-custom"
                  value={basicInfo?.gender || ""}
                  name="gender"
                  onChange={(e) => handleBasicInfoChange(e)}
                >
                  <option value="">Select Gender</option>
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                  <option value="O">Others</option>
                </select>
              </label>
            </div>
            {error?.gender && <p className="field-error">{error?.gender}</p>}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>Contact No</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="phoneNumber"
                  value={basicInfo?.phoneNumber || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.phoneNumber && (
              <p className="field-error">{error?.phoneNumber}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group mt-2">
              <label className="has-float-label">
                <span>Whatsapp No</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="whatsappNumber"
                  value={basicInfo?.whatsappNumber || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.whatsappNumber && (
              <p className="field-error">{error?.whatsappNumber}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group mt-2">
              <label className="has-float-label">
                <span>Country</span>
                <select
                  class="form-control gen-select"
                  value={basicInfo?.address?.country}
                  name="country"
                  onChange={(e) => handleBasicInfoChange(e)}
                  disabled={true}
                >
                  {countryList && countryList?.length > 0 && (
                    <option value="">Select option</option>
                  )}
                  {countryList &&
                    countryList?.length > 0 &&
                    countryList.map(({ id, name }) => {
                      return (
                        <option key={id} value={id}>
                          {name || ""}
                        </option>
                      );
                    })}
                </select>
              </label>
            </div>
            {error?.country && <p className="field-error">{error?.country}</p>}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group mt-2">
              <label className="has-float-label">
                <span>State</span>
                <select
                  class="form-control gen-select"
                  value={basicInfo?.address?.state}
                  name="state"
                  onChange={(e) => handleBasicInfoChange(e)}
                >
                  {stateList && stateList?.length > 0 && (
                    <option value="">Select option</option>
                  )}
                  {stateList &&
                    stateList?.length > 0 &&
                    stateList.map(({ id, name }) => {
                      return (
                        <option key={id} value={id}>
                          {name || ""}
                        </option>
                      );
                    })}
                </select>
              </label>
            </div>
            {error?.state && <p className="field-error">{error?.state}</p>}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group mt-2">
              <label className="has-float-label">
                <span>City</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="city"
                  value={basicInfo?.address?.city || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.city && <p className="field-error">{error?.city}</p>}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>LinkedIn Profile</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="linkedinProfile"
                  value={basicInfo?.linkedinProfile || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.linkedinProfile && (
              <p className="field-error">{error?.linkedinProfile}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>Facebook Profile</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="facebookProfile"
                  value={basicInfo?.facebookProfile || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.facebookProfile && (
              <p className="field-error">{error?.facebookProfile}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>Instagram Profile</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="instagramProfile"
                  value={basicInfo?.instagramProfile || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.instagramProfile && (
              <p className="field-error">{error?.instagramProfile}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>Youtube Profile</span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="youtubeProfile"
                  value={basicInfo?.youtubeProfile || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.youtubeProfile && (
              <p className="field-error">{error?.youtubeProfile}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group">
              <label className="has-float-label">
                <span>
                  X Profile{" "}
                  <span className="tweet-note">
                    (Add only the profile name without @symbol)
                  </span>
                </span>
                <input
                  className="form-control py-4"
                  type="text"
                  name="xProfile"
                  value={basicInfo?.xProfile || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                />
              </label>
            </div>
            {error?.xProfile && (
              <p className="field-error">{error?.xProfile}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group mt-2">
              <label className="has-float-label">
                <span>Languages</span>
                <Multiselect
                  options={languageList}
                  hidePlaceholder={true}
                  closeOnSelect={false}
                  onSelect={(val) =>
                    setBasicInfo({ ...basicInfo, language: val })
                  }
                  onRemove={(val) =>
                    setBasicInfo({ ...basicInfo, language: val })
                  }
                  selectedValues={basicInfo?.language}
                  displayValue="name"
                  className="multi-select-wrapper"
                />
              </label>
            </div>
            {error?.language && (
              <p className="field-error">{error?.language}</p>
            )}
          </div>
          <div className="col-md-12">
            <div className="form-group input-group mt-2">
              <label className="has-float-label">
                <span>Categories</span>
                <Multiselect
                  options={categoryList}
                  hidePlaceholder={true}
                  closeOnSelect={false}
                  onSelect={(val) =>
                    setBasicInfo({ ...basicInfo, skillsCategory: val })
                  }
                  onRemove={(val) =>
                    setBasicInfo({ ...basicInfo, skillsCategory: val })
                  }
                  selectedValues={basicInfo?.skillsCategory}
                  displayValue="name"
                  className="multi-select-wrapper"
                />
              </label>
            </div>
            {error?.skillsCategory && (
              <p className="field-error">{error?.skillsCategory}</p>
            )}
          </div>
          {/* <div className="col-md-12">
            <div className="form-group ">
              <label className="switch-label">
                <span>You want to offer Service?</span>
              </label>
              <label class="switch">
                <input
                  type="checkbox"
                  checked={basicInfo?.offerService || false}
                  onChange={() =>
                    setBasicInfo({
                      ...basicInfo,
                      offerService: !basicInfo.offerService,
                    })
                  }
                />
                <span class="slider round"></span>
              </label>
            </div>
            {error?.offerService && (
              <p className="field-error">{error?.offerService}</p>
            )}
          </div> */}
        </div>
      </div>
      <div className="modal-footer mt-2 mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-outline-primary modal-btn"
          onClick={formValidation}
        >
          Save
        </button>
      </div>
    </>
  );
  // );
};

export default AddBasicInfo;
